/* eslint-disable */
const royalAppdynamics = () => {
  window['adrum-start-time'] = new Date().getTime();
  (function (config) {
    config.appKey = process.env.REACT_APP_APPDYNAMICS_APP_KEY;
    config.adrumExtUrlHttp = 'http://cdn.appdynamics.com';
    config.adrumExtUrlHttps = 'https://cdn.appdynamics.com';
    config.beaconUrlHttp = 'http://pdx-col.eum-appdynamics.com';
    config.beaconUrlHttps = 'https://pdx-col.eum-appdynamics.com';
    config.useHTTPSAlways = true;
    config.resTiming = { bufSize: 300, clearResTimingOnBeaconSend: true };
    config.xd = { enable: true };
    config.maxUrlLength = 2048;
    config.enableCoreWebVitals = true;
    config.spa = { spa2: { clearResTiming: true } };
    config.navComplete = {
      maxResourceQuietTime: 500,
      maxXhrQuietTime: 500,
      maxInactiveTime: 500,
    };
    let pageName = '';
    //set error page names
    switch (window.document.title) {
      case 'Page Not Found | Royal Caribbean Cruises':
        pageName = '404 Error Page';
        break;
      case 'Server Error | Royal Caribbean Cruises':
        pageName = '5xx Error Page';
        break;
    }
    function getCookieValue(cookieName) {
      try {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + cookieName + '=');
        if (parts.length == 2) {
          return parts.pop().split(';').shift();
        } else {
          return '';
        }
      } catch (err) {
        return 'error';
      }
    }
    //send data to appd
    config.userEventInfo = {
      PageView: function (context) {
        return {
          userPageName: pageName,
          userData: {
            BlueGreenValue: getCookieValue('bgv'),
            MarketingCloudID: getCookieValue('MCMID'),
            LoyaltyID: getCookieValue('loyalty_ID'),
            JSession: getCookieValue('jsess'),
            BookingID: getCookieValue('booking_ID'),
            WUC: getCookieValue('wuc'),
            country: getCookieValue('country'),
            currency: getCookieValue('currency'),
            autSession: getCookieValue('autsession'),
          },
          userDataLong: {
            cookieSize: encodeURIComponent(`<q></q>${document.cookie}`).length,
          },
        };
      },
      Ajax: function (context) {
        return {
          userData: {
            BlueGreenValue: getCookieValue('bgv'),
            MarketingCloudID: getCookieValue('MCMID'),
            LoyaltyID: getCookieValue('loyalty_ID'),
            JSession: getCookieValue('jsess'),
            BookingID: getCookieValue('booking_ID'),
            WUC: getCookieValue('wuc'),
            country: getCookieValue('country'),
            currency: getCookieValue('currency'),
            autSession: getCookieValue('autsession'),
          },
          userDataLong: {
            cookieSize: encodeURIComponent(`<q></q>${document.cookie}`).length,
          },
        };
      },
      VPageView: function (context) {
        return {
          userData: {
            BlueGreenValue: getCookieValue('bgv'),
            MarketingCloudID: getCookieValue('MCMID'),
            LoyaltyID: getCookieValue('loyalty_ID'),
            JSession: getCookieValue('jsess'),
            BookingID: getCookieValue('booking_ID'),
            WUC: getCookieValue('wuc'),
            country: getCookieValue('country'),
            currency: getCookieValue('currency'),
            autSession: getCookieValue('autsession'),
          },
          userDataLong: {
            cookieSize: encodeURIComponent('<q></q>' + document.cookie).length,
          },
        };
      },
    };
  })(window['adrum-config'] || (window['adrum-config'] = {}));
};

export default royalAppdynamics;
